import axios, { CancelToken } from 'axios';
import authService from './authService';
import { getAuthHeader } from './utils/authHelper';
import { getEnv } from '../utils/envUtils';

const AUTOCOMPLETE_API_URL = getEnv('REACT_APP_STATISTICS_API');
const WORD_ENDPOINT = '/search/words';
const PLACE_ENDPOINT = '/search/places';
const COMPANY_ENDPOINT = '/search/companies';

let cancel;

const mapToObject = data => data.map(suggestion => ({
    value: suggestion,
    label: suggestion,
}));

const getSuggestions = (query, endpoint) => {
    const params = {
        limit: 10,
        query: query ? query.trim() : '',
    };

    const buildRequest = () => ({
        method: 'GET',
        headers: {
            Accept: 'application/json',
            Authorization: getAuthHeader(),
        },
        params,
        url: `${AUTOCOMPLETE_API_URL}${endpoint}`,
        cancelToken: new CancelToken(((c) => { cancel = c; })),
    });

    if (cancel) {
        cancel();
    }

    return axios(buildRequest())
        .catch(err => authService.refreshAndRetry(err, buildRequest));
};

export const getSearchWordSuggestions = query => getSuggestions(query, WORD_ENDPOINT)
    .then(response => mapToObject(response.data || []));

export const getPlaceSuggestions = query => getSuggestions(query, PLACE_ENDPOINT)
    .then(response => mapToObject(response.data || []));

export const getCompanyNameSuggestions = query => getSuggestions(query, COMPANY_ENDPOINT)
    .then(response => response.data || []);

export const getFormattedCompanyNameSuggestions = (query) => {
    return getCompanyNameSuggestions(query).then(suggestions => {
        return suggestions.map(name => {
            const match = name.match(/\(([^)]+)\)/);
            const value = match ? match[1] : name;
            return {
                value: value,
                label: name,
            };
        });
    });
};


const api = {
    getSearchWordSuggestions,
    getPlaceSuggestions,
    getCompanyNameSuggestions,
    getFormattedCompanyNameSuggestions,
};

export default api;
